<template lang="pug">
ul.links.flex_h
  li(
    v-for="(link, index) in links",
    :key="index",
    :class="{ selected: $route.name && $route.name.includes(link.pageName) && $store.state.navigationStyle == 1, business: $route.name && $route.name.includes(link.pageName) && $store.state.navigationStyle == 2 }"
  )
    router-link(v-if="link.pageName", tag="a", :to="{ name: link.pageName }") {{ link.name }}

    a(v-if="link.url", :href="link.url") {{ link.name }}
</template>
<script>
export default {
  name: "Links",
  data() {
    return {
      links: [
        // {
        //   name: "網路投保",
        //   url: "https://www.tmnewa.com.tw/b2c_v2/frontstage/welcome.aspx",
        // },
        {
          name: "商品櫥窗",
          pageName: "Product",
        },
        {
          name: "客戶服務",
          pageName: "CustomerService",
        },
        {
          name: "認識我們",
          pageName: "AboutUs",
        },
        {
          name: "公平待客",
          url: "/customize/manager",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/footer/link";
</style>
